"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _lodash = require("lodash");
var _clsx = _interopRequireDefault(require("clsx"));
var _styles = require("@material-ui/core/styles");
var _bookmarkContext = _interopRequireDefault(require("../../context/bookmarkContext"));
var _svgicon = _interopRequireDefault(require("../../helper/svgicon"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const useStyles = (0, _styles.makeStyles)(theme => {
  var _theme$palette$backgr, _theme$palette$foregr, _theme$palette$backgr2;
  return {
    root: {
      alignItems: "center",
      backgroundColor: (_theme$palette$backgr = theme.palette.background) === null || _theme$palette$backgr === void 0 ? void 0 : _theme$palette$backgr.bookmark,
      borderRadius: "50%",
      color: (_theme$palette$foregr = theme.palette.foreground) === null || _theme$palette$foregr === void 0 ? void 0 : _theme$palette$foregr.bookmark,
      cursor: "pointer",
      display: "flex",
      height: theme.spacing(3.5),
      justifyContent: "center",
      transition: theme.transitions.create(["background-color"]),
      width: theme.spacing(3.5),
      "&:hover": {
        background: theme.palette.primary.main
      }
    },
    selected: {
      backgroundColor: (_theme$palette$backgr2 = theme.palette.background) === null || _theme$palette$backgr2 === void 0 ? void 0 : _theme$palette$backgr2.bookmarkActive
    },
    absolute: {
      position: "absolute",
      right: theme.spacing(1),
      top: theme.spacing(1),
      zIndex: theme.zIndex.bookmark
    },
    relative: {
      position: "relative"
    }
  };
});
const BookmarkIcon = props => {
  const {
    id,
    type = "",
    title,
    addition = "",
    link,
    position = "absolute"
  } = props;
  const [bookmarkData, setBookmarkData] = (0, _react.useContext)(_bookmarkContext.default);
  const css = useStyles();
  const UpdateBookmark = () => {
    if (IsBookmarked()) {
      setBookmarkData([]);
      RemoveBookmark();
    } else {
      setBookmarkData([]);
      AddBookmark();
    }
  };
  const IsBookmarked = () => {
    const bookmarks = GetBookmarks();
    return bookmarks.some(item => {
      return item.id === id && item.type === type;
    });
  };
  const AddBookmark = () => {
    const bookmarks = GetBookmarks();
    bookmarks.push({
      id,
      type,
      title,
      addition,
      link
    });
    SetBookmarks(bookmarks);
  };
  const RemoveBookmark = () => {
    const bookmarks = GetBookmarks();
    (0, _lodash.remove)(bookmarks, item => {
      return item.id === id && item.type === type;
    });
    SetBookmarks(bookmarks);
  };
  const GetBookmarks = () => {
    return [...bookmarkData];
  };
  const SetBookmarks = bookmarks => {
    setBookmarkData(bookmarks);
    localStorage.setItem("bookmark", JSON.stringify(bookmarks));
  };
  return /*#__PURE__*/_react.default.createElement(_svgicon.default, {
    onClick: () => UpdateBookmark(),
    className: (0, _clsx.default)({
      [css.root]: true,
      [css.selected]: IsBookmarked(),
      [css[position]]: !!position
    }),
    src: "/img/icons/heart.svg",
    size: 16
  });
};
var _default = exports.default = BookmarkIcon;